import antd from 'ant-design-vue/es/locale-provider/ja_JP';
import dayjsLocale from 'dayjs/locale/ja';
import momentEnCA from 'moment/dist/locale/en-ca';
import data from '../json/ja.json';

const components = {
  antLocale: antd,
  momentName: 'ja',
  momentLocale: momentEnCA,
  dayjsName: 'ja',
  dayjsLocale
};

export default {
  ...components,
  ...data
};
